// extracted by mini-css-extract-plugin
module.exports = {"about":"Q5X1zeTp","banner":"kLOar1Nk","logo":"JqpK4um1","title":"TgaoYHcO","seation":"GMWfD9Cu","container":"EIS1V69t","col2":"hmKJ_ahl","col4":"pzgYVadu"};